import { capitalize, uniqBy } from 'lodash'

const getDefaultState = () => {
  return {
    filtresAdherent: {},
    filtresValeursPossibles: {
      categoriesContrats: [],
      numerosContrats: [],
      etatsLogistiques: [],
      etatsPaiements: [],
    },
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),

  getters: {
    filtresAdherent (state) {
      return state.filtresAdherent
    },
    filtresValeursPossibles (state) {
      return state.filtresValeursPossibles
    },
  },
  mutations: {
    SET_FILTRES_ADHERENT (state, filtresAdherent) {
      state.filtresAdherent = filtresAdherent
    },
    SET_VALEURS_CATEGORIES_CONTRATS (state, categoriesContrats) {
      state.filtresValeursPossibles.categoriesContrats = categoriesContrats
    },
    SET_VALEURS_NUMEROS_CONTRATS (state, numerosContrats) {
      state.filtresValeursPossibles.numerosContrats = numerosContrats
    },
    SET_VALEURS_STATUTS_LIVRAISON (state, etatsLogistiques) {
      state.filtresValeursPossibles.etatsLogistiques = etatsLogistiques
    },
    SET_VALEURS_ETATS_REGLEMENT (state, etatsPaiements) {
      state.filtresValeursPossibles.etatsPaiements = etatsPaiements
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    initFiltres ({ dispatch, getters }, params) {
      const resumeContrats = params.resumesContrats.length ? params.resumesContrats : []
      Promise.all([
        dispatch('setValeursCategoriesContrats', resumeContrats),
        dispatch('setValeursNumerosContrats', resumeContrats),
        dispatch('setValeursEtatsLogistiques', resumeContrats),
        dispatch('setValeursEtatsPaiements', resumeContrats)
      ]).then(() => {
        const filtresAdherent = {
          categorieContrat: params.categorieContrat && params.categorieContrat != null ? params.categorieContrat : getters.filtresValeursPossibles.categoriesContrats[0],
          numeroContrat: params.numeroContrat && params.numeroContrat != null ? params.numeroContrat : getters.filtresValeursPossibles.numerosContrats[0],
          etatLogistique: params.etatLogistique && params.etatLogistique != null ? params.etatLogistique : [{ code: 'TOUS', libelle: 'Tous' }],
          etatPaiement: getters.filtresValeursPossibles.etatsPaiements[0],
        }
        dispatch('setFiltres', filtresAdherent)
      })
    },
    setValeursCategoriesContrats ({ commit }, resumeContrats) {
      //Le set permet d'avoir des valeurs distinctes
      const categoriesContrats = ['Tous', ...new Set(resumeContrats
        .map(contrat => contrat.type.categorieContrat)
        .sort())]
      return commit('SET_VALEURS_CATEGORIES_CONTRATS', categoriesContrats)
    },
    setValeursNumerosContrats ({ commit }, resumeContrats) {
      //Le set permet d'avoir des valeurs distinctes
      const numerosContrats = ['Tous', ...new Set(resumeContrats
        .map(contrat => contrat.numeroContrat)
        .filter(numeroContrat => !!numeroContrat)
        .sort())]
      // Recherche si présence de contrat de type TRESO_MOISSON_A_FIXER, si oui ajout de Sans contrat dans la liste des valeurs possibles
      const nbContratsTresoMoissonAFixer = resumeContrats.filter(contrat => contrat.type.code === 'TRESO_MOISSON_A_FIXER').length
      if (nbContratsTresoMoissonAFixer > 0) {
        numerosContrats.push('Sans contrat')
      }
      return commit('SET_VALEURS_NUMEROS_CONTRATS', numerosContrats)
    },
    setValeursEtatsLogistiques ({ commit }, resumeContrats) {
      //Le set permet d'avoir des valeurs distinctes
      const etatsLogistiques = uniqBy(resumeContrats
        .map(contrat => contrat.etatLogistique)
        .sort(), 'code')
      return commit('SET_VALEURS_STATUTS_LIVRAISON', etatsLogistiques)
    },
    setValeursEtatsPaiements ({ commit }, resumeContrats) {
      //Le set permet d'avoir des valeurs distinctes
      const etatsPaiements = ['Tous', ...new Set(resumeContrats
        .map(contrat => capitalize(contrat.etatPaiement.libelle))
        .sort())]
      return commit('SET_VALEURS_ETATS_REGLEMENT', etatsPaiements)
    },

    setFiltres ({ commit }, filtresAdherent) {
      return commit('SET_FILTRES_ADHERENT', filtresAdherent)
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
